<template>
  <div class="benefits-list">
    <div class="benefits-list__item  _no-link" :class="{_active: icons.observation}">
      <BaseSvg name="ico-thermometer"/>
      <div v-if="icons.observation" class="benefits-list__tooltip">
        {{ $tVacancy('With observation housing') }}
      </div>
      <div v-else class="benefits-list__tooltip">
        {{ $tVacancy('Observation housing') }} <span class="text-nowrap">{{ $tVacancy('not provided') }}</span>
      </div>
    </div>
    <div class="benefits-list__item  _no-link" :class="{_active: icons.housing}">
      <BaseSvg name="ico-house"/>
      <div v-if="icons.housing" class="benefits-list__tooltip">
        {{ $tVacancy('With housing') }}
      </div>
      <div v-else class="benefits-list__tooltip">
        {{ $tVacancy('Housing') }} <span class="text-nowrap">{{ $tVacancy('not provided') }}</span>
      </div>
    </div>

    <div class="benefits-list__item  _no-link" :class="{_active: icons.meals}">
      <BaseSvg name="ico-cutlery"/>
      <div v-if="icons.meals" class="benefits-list__tooltip">
        {{ $tVacancy('With meals') }}
      </div>
      <div v-else class="benefits-list__tooltip">
        {{ $tVacancy('Meals') }} <span class="text-nowrap">{{ $tVacancy('not provided') }}</span>
      </div>
    </div>

    <div class="benefits-list__item  _no-link" :class="{_active: icons.transport}">
      <BaseSvg name="ico-transport"/>
      <div v-if="icons.transport" class="benefits-list__tooltip">
        {{ $tVacancy('With transport') }}
      </div>
      <div v-else class="benefits-list__tooltip">
        {{ $tVacancy('Transport') }} <span class="text-nowrap">{{ $tVacancy('not provided') }}</span>
      </div>
    </div>

    <div class="benefits-list__item  _no-link" :class="{_active: icons.clothes}">
      <BaseSvg name="ico-t-shirt"/>
      <div v-if="icons.clothes" class="benefits-list__tooltip">
        {{ $tVacancy('With clothes') }}
      </div>
      <div v-else class="benefits-list__tooltip">
        {{ $tVacancy('Clothes') }} <span class="text-nowrap">{{ $tVacancy('not provided') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      vacancy: {
        type: Object,
        required: true
      }
    },
    computed: {
      icons() {
        const section = this.vacancy[1];

        return {
          observation: !!(section.conditions_observation_housing || section.conditions_observation_housing_type),
          housing: !!(section.conditions_housing || section.conditions_housing_type || section.conditions_housing_description),
          meals: !!(section.conditions_meals || section.conditions_meals_type),
          transport: !!(section.conditions_transport || section.conditions_transport_type),
          clothes: !!(section.conditions_clothes || section.conditions_clothes_type)
        };
      },
    }
  }
</script>

<style lang="less">

</style>